import React from "react";
import TableWrapper from "../../elements/TableWrapper";
import moment from "moment";
import TierProfile from "../../elements/TierProfile";
import OverrideProfileVal from "../../elements/OverrideProfileVal";
import {
  Row,
  Col,
  Modal,
  Form,
  Select,
  message,
  Input, Empty,Icon
} from "antd";
import MiCompAPI from "../../../util/api";
import AliceCarousel from 'react-alice-carousel'
import img from '../../../assets/img/success.png';
const { confirm } = Modal;
const { Option } = Select;
class BrokerPlanandProfile extends React.Component {
  client_broker_profile_columns = [
    {
      title: "Profile Name",
      dataIndex: "tier_profile_name",
      render: (text, record) => <><h6 className="mi_ancor" onClick={() => { this.GetClient_TierandProfileById(record) }} >{text}</h6> </>,
      sorter: (a, b) => a.tier_profile_name.localeCompare(b.tier_profile_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Plan Name",
      dataIndex: "plan_name",
      sorter: (a, b) => a.plan_name.localeCompare(b.plan_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Plan Id",
      dataIndex: "client_plan_Id",
    },
    {
      title: "Company Name",
      dataIndex: "client_name",
      sorter: (a, b) => a.client_name.localeCompare(b.client_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "IsOverride",
      render: (record) => (record["override_tier_value"] !== 0 && record["override_tier_value"] !== null) ? 'Yes' : 'No'
    },
    {
      title: "Override Value",
      render: (record) => (record["override_tier_value"] !== 0 && record["override_tier_value"] !== null) ? record["override_tier_value"] + "%" : 'none'
    },
    {
      title: "Action",
      dataIndex: "",
      render: () => <> <img height="14" alt="" style={{ marginLeft: '15px' }} width="14" src={img}></img> </>
    },
  ];
  client_profile_columns = [
    {
      title: "Profile Name",
      dataIndex: "tier_profile_name",
      render: (text, record) => <> <h6 className="mi_ancor" onClick={() => { this.GetClient_TierandProfileById(record) }} >{text}</h6> </>,
      sorter: (a, b) => a.tier_profile_name.localeCompare(b.tier_profile_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Reimbursement Type",
      dataIndex: "reimb_type_name",
      sorter: (a, b) => a.reimb_type_name.localeCompare(b.reimb_type_name),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Min Allowance",
      dataIndex: "min_allow",
    },
    {
      title: "Max Allowance",
      dataIndex: "max_allow",
    },
    {
      title: "Qualifier",
      dataIndex: "qualifier_value",
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      render: (text, record) => record["start_date"] !== null && record["start_date"] !== "" ? moment(record["start_date"]).format("MM/DD/YYYY") : "",
      sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      render: (text, record) => record["end_date"] !== null && record["end_date"] !== "" ? moment(record["end_date"]).format("MM/DD/YYYY") : "",
      sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Calculation Method",
      dataIndex: "reimb_cal_meth",
      render: (text) => (text ? "Percentage" : "Fixed"),
      sorter: (a, b) => a.reimb_cal_meth.localeCompare(b.reimb_cal_meth),
      sortDirections: ["descend", "ascend"]
    }, {
      title: "Action",
      dataIndex: "",
      render: (record) => <>{this.state.client_broker_profile[0] ? record.tier_profile_id === this.state.client_broker_profile[0].tier_profile_id ? <img height="14" alt="" style={{ marginLeft: '15px' }} width="14" src={img}></img> :

        <input onClick={() => this.showConfirm(record)} type="radio" name="tier_profile_name" style={{ marginLeft: '15px', height: '12px', width: '12px' }} />
        : <input onClick={() => this.showConfirm(record)} type="radio" name="tier_profile_name" style={{ marginLeft: '15px', height: '12px', width: '12px' }} />
      }  </>
    }
  ];

  showConfirm = (record) => {
    confirm({
      title: 'Do you need to override the profile ?',
      onOk: () =>
        this.addOverrideDefaultHandler(record),
      okText: "yes",
      cancelText: "No",
      onCancel: () =>
        this.handleSubmit(record, 0)
      ,
    });
  }
  constructor(props) {
    super(props);


    this.state = {
      planvalid: null,
      search_val: null,
      lobs: [],
      addOverrideActive: false,
      addOverrideActiveRecord: [],
      lob: 0,
      tier: null,
      isLoading: true,
      slideToIndex: 0,
      client_broker_profile: [],
      Tiers: [],
      Profiles: [],
      selectedRowKeys: [],
      isProfileShow: false,
      record: []
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  addOverrideDefaultHandler = (val) => {
    this.setState({ addOverrideActive: !this.state.addOverrideActive, addOverrideActiveRecord: val })
  }
  addOverrideSubmitHandler = (data) => {
    this.handleSubmit(this.state.addOverrideActiveRecord, data.override_val);
  }
  handleSubmit = (e, override_tier_value) => {
    let data = {
      user_id: this.props.User_Id,
      client_id: e.client_TierADataModel.client_id,
      tier_profile_id: e.tier_profile_id,
      tier_id: e.tier_id,
      override_tier_no: 0,
      override_tier_value: override_tier_value,
    };
    this.api.invoke(
      "SaveAndUpdateClient_User_Profiles",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.GetCurrentClient_Broker_ProfilesbyTierID(e.tier_id);
            this.setState({ addOverrideActive: false, addOverrideActiveRecord: null })
            message.destroy();
            message.success(data.statusMessage, 3);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  };
  componentDidMount = () => {
    this.getMaters();
    this.getTiersByClientIdandLoBID(0);
  };
  UserDefaultHandler = (record) => {
    this.setState({
      record,
      isProfileShow: !this.state.isProfileShow
    })
  }
  getMaters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({ lobs: data.lobs });
        }
      }, ["LOB"]
    );
  }
  getTiersByClientIdandLoBID = (lob_id) => {
    this.api.invoke(
      "GetTiersByClientIdandLoBID/"+this.props.User_Id+"/" + lob_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              loading: false,
              Tiers: (this.state.search_val !== null && this.state.search_val !== "") ? data.data.map(x => ({ ...x, isActiveTab: false })).filter(o =>
                Object.keys(o).some(k =>
                  String(o[k])
                    .toLowerCase()
                    .includes(this.state.search_val.toLowerCase())
                )
              ) : data.data.map(x => ({ ...x, isActiveTab: false }))
            });
            if (this.state.Tiers.length > 0)
              this.getTier_ProfilesByTierId(this.state.Tiers[0]);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  };
  getTier_ProfilesByTierId = (tier) => {
    this.GetCurrentClient_Broker_ProfilesbyTierID(tier.tier_id)
    this.setState({
      Tiers: this.state.Tiers.map((x, index) => {
        if (x.tier_id === tier.tier_id) {
          this.setState({
            slideToIndex: index
          })
          return { ...x, isActiveTab: true }
        } else {
          return { ...x, isActiveTab: false }
        }
      }),
    });
    this.api.invoke(
      "GetAllClient_Tier_ProfileByTierId/" +
      tier.tier_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              loading: false,
              Profiles: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  };
  Change = (key, e) => {

    if (key === "lob") {
      this.setState({ lob: e });
    }
    if (key === "sea") {
      this.setState({ search_val: e.target.value });
    }
    setTimeout(() => {
      this.setState({ planvalid: null });
      this.getTiersByClientIdandLoBID(this.state.lob);
      this.setState({
        Tiers: this.state.Tiers
      })
    }, 1);
  };
  GetClient_TierandProfileById = (data) => {
    this.api.invoke(
      "GetClient_TierandProfileById/" +
      data.tier_profile_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            this.setState({
              isProfileShow: true,
              record: { ...data.data.Tier_Profile, client_TierADataModel: data.data.Tier },
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  };
  GetCurrentClient_Broker_ProfilesbyTierID = (tier_id) => {
    ;
    this.api.invoke(
      "GetCurrentClient_User_ProfilesbyTierID/" +
      tier_id + "/" + this.props.User_Id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              loading: false,
              client_broker_profile: data.data ? [{ ...data.data }] : [],
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  };
  render() {
    return (
      <div>
        {this.state.addOverrideActive ? (
          <Modal
            visible={this.state.addOverrideActive}
          >
            <OverrideProfileVal
              closeDrawerHandler={this.addOverrideDefaultHandler}
              submitHandler={this.addOverrideSubmitHandler}
              width={500} />
          </Modal>
        ) : null}
        {(this.state.isProfileShow) ? <Modal
          visible={this.state.isProfileShow}
        > <TierProfile Client_Tier={this.state.record.client_TierADataModel} title="Profile Details"
          Tier_Profile={this.state.record} closeDrawerHandler={() => { this.UserDefaultHandler(null) }} /></Modal> : null}
        <Form layout="vertical" hideRequiredMark>
          <div style={{ margin: '10px' }}>
            <Row gutter={24}>
              <Col sm={24} md={8}>

              </Col>
              <Col sm={24} md={8}>
                {" "}

            <fieldset className="mi_input_pop" style={{marginLeft:'100px',marginRight: '-28px'}}>
              <legend className="legend-font">LOA</legend>
                {/* <Form.Item label={<h4>LOA</h4>}> */}
                  <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"
                    onChange={this.Change.bind(this, "lob")}
                    placeholder="Please Select LOA *"
                    showSearch={true}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="0" key="0">None</Option>
                    {this.state.lobs.map((tag) => (
                      <Option value={tag.name} key={tag.name}>
                        {tag.name}
                      </Option>
                    ))}
                  </Select>
                {/* </Form.Item> */}
                </fieldset>
              </Col>
              <Col sm={24} md={8}>
              <div style={{ float: 'right',  marginLeft: '20px',marginTop:"24px" }}>
                  <Input.Search
                    style={{marginTop:'0px'  }}
                    placeholder="Search"
                    className="table-search-button"
                    onChange={this.Change.bind(this, "sea")}
                  /></div>
              </Col>
            </Row>
          </div>
          <Row span={24}>
            {this.state.Tiers.length > 3 || window.innerWidth < 760 ?
              <AliceCarousel
                startIndex={this.state.slideToIndex}
                stopAutoPlayOnHover={false}
                responsive={{
                  0: { items: 1 },
                  1024: { items: 3 },
                }} dotsDisabled={true} >
                {this.state.Tiers.map((item) => {
                  return (<Col  >
                    <div className={item.isActiveTab ? "Rectangle-1" : "Rectangle-3"} onClick={() => this.getTier_ProfilesByTierId(
                      item)}>
                      <div style={{ transform: 'rotate(180deg)' }}>
                        <Row span={24}>
                          <Col span={15}>
                            <p className="mi_plan_title">{item.plan_Name} </p>
                          </Col>
                          <Col span={9}>
                            <p className="mi_plan_badge">{"id : " + item.client_plan_Id}</p>
                          </Col>
                        </Row>
                        <Row span={24}>
                          <Col span={12}>
                            <p className="mi_plan_start">{item.start_date ? "Start date : " + moment(item.start_date).format("MM/DD/YYYY") : 'none'} </p>
                          </Col>
                          <Col span={12}>
                            <p className="mi_plan_start" style={{ float: 'right' }}>{item.end_date ? "End date : " + moment(item.end_date).format("MM/DD/YYYY") : 'none'}</p>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>)
                })}
              </AliceCarousel> :
              this.state.Tiers.map((item) => {
                return (<Col md={8} >
                  <div className={item.isActiveTab ? "Rectangle-1" : "Rectangle-3"} onClick={() => this.getTier_ProfilesByTierId(
                    item)}>
                    <div style={{ transform: 'rotate(180deg)' }}>
                      <Row span={24}>
                        <Col span={15}>
                          <p className="mi_plan_title">{item.plan_Name} </p>
                        </Col>
                        <Col span={9}>
                          <p className="mi_plan_badge">{"id : " + item.client_plan_Id}</p>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={12}>
                          <p className="mi_plan_start">{item.start_date ? "Start date : " + moment(item.start_date).format("MM/DD/YYYY") : 'none'} </p>
                        </Col>
                        <Col span={12}>
                          <p className="mi_plan_start" style={{ float: 'right' }}>{item.end_date ? "End date : " + moment(item.end_date).format("MM/DD/YYYY") : 'none'}</p>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>)
              })}
          </Row>
          {this.state.Tiers.length > 0 ?
            <Row span={24}>
              <div style={{ margin: '25px 10px' }}>
                <TableWrapper
                  title="Current profiles"
                  columns={this.client_broker_profile_columns}
                  data={this.state.client_broker_profile}
                  pagination={false}
                />
              </div>
              <div style={{ margin: '25px 10px' }}>
                <TableWrapper bordered={true} title="Assign Profiles"
                  columns={this.client_profile_columns}
                  data={this.state.Profiles}
                />
              </div>
            </Row>
            : <Empty />}
        </Form>
      </div>
    );
  }
}
export default BrokerPlanandProfile;
